<div class="container-fluid d-flex flex-column h-100">
  <div class="row py-3 g-3">
    <div class="col-4">
      <button class="btn btn-primary">Upload Exempt Vendor File</button>
    </div>

    <div class="col-4">
      <button class="btn btn-primary">Download Exempt Vendor Template</button>
    </div>

    <div class="col-4">
      <button class="btn btn-primary">Download Exempt Vendor Types</button>
    </div>
  </div>
  <div class="row flex-grow-1">
    <div class="col">
      <app-company-vendors-grid
        [gridName]="'ClientVendors'"
        [suppliedQueryData]="SuppliedQueryData"
        (rowClick)="actionEvent({ action: 'view', rowData: $event.data })"
      ></app-company-vendors-grid>
    </div>
  </div>
</div>
